import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles(({ palette }) => ({
    dutyTime: { fontWeight: 600 },
    text: {
        color: palette.type === 'light' ? palette.grey['700'] : palette.accent3Color,
    }
}));
